import { format } from "d3";
import { get } from "lodash";
import { array, bool, func, object, shape, string } from "prop-types";
import React, { Component } from "react";
import { required as isRequired } from "../validations";

const getFormattedNumber = (value, formatter = format(",")) => {
  if (typeof value === "undefined" || value === "" || isNaN(value)) {
    return value;
  }
  return formatter(value);
};

// provides render prop accessing form model/actions from context provided
// by parent Form component
export default class InputWrapper extends Component {
  static propTypes = {
    name: string.isRequired,
    render: func.isRequired,

    type: string,
    validations: array,
    required: bool,
    customValue: func,
    formatNumber: func,
  };

  state = {
    editing: false,
  };

  static defaultProps = {
    type: "text",
    validations: [],
    required: false,
  };

  static contextTypes = {
    form: object.isRequired,
    formActions: object.isRequired,
  };

  componentDidMount() {
    const { name, required } = this.props;
    const validations = [...this.props.validations];
    required && validations.unshift(isRequired);
    this.context.formActions.registerValidations(name, validations);
  }

  componentWillUnmount() {
    this.context.formActions.unregisterValidations(this.props.name);
  }

  showRealValue = () => this.setState({ editing: true });

  showPrettyValueAndValidate = async () => {
    const {
      formActions: { validateField },
    } = this.context;
    const { name } = this.props;

    await validateField(name);

    this.setState({ editing: false });
  };

  formatNumber = () => {
    const {
      form: { formModel },
    } = this.context;
    const { editing } = this.state;
    const { name, render, customValue, formatNumber } = this.props;
    if (customValue) {
      return customValue(formModel);
    }
    const value = get(formModel, name, "");
    return this.props.type === "number" && !editing
      ? getFormattedNumber(value, formatNumber)
      : value;
  };

  render() {
    const {
      form: { formModel, errors, validating, formValidating, formDisabled },
      formActions: { updateFormModel, validateField },
    } = this.context;

    const { name, type, render, customValue } = this.props;

    return render({
      value: this.formatNumber(),
      update: updateFormModel.bind(null, name, type),
      updateFormModel,
      error: errors[name],
      formValidating: formValidating,
      inputValidating: validating[name],
      formDisabled,
      onFocus: this.showRealValue,
      onBlur: this.showPrettyValueAndValidate,
    });
  }
}
